__turbopack_context__.v({
  "dropdown": "account-referral-container-module-sass-module__SJVB0a__dropdown",
  "referral": "account-referral-container-module-sass-module__SJVB0a__referral",
  "referralList": "account-referral-container-module-sass-module__SJVB0a__referralList",
});
